import axios from "axios";
import config from "../environment/config";
import { authHeader } from "./auth.header";

const API_URL = config.API_URL + '/api';

const profileService = {

  // -------------------------------------------
  // GET PROFILE - Uses JWT token
  // Backend: @GetMapping("/userProfile")
  // URL: /api/seo-user/userProfile
  // -------------------------------------------
  getProfile: async () => {
    try {
      console.log("🔍 GET Profile URL:", `${API_URL}/seo-user/userProfile`);
      console.log("🔍 Auth Headers:", authHeader());

      const response = await axios.get(`${API_URL}/seo-user/userProfile`, {
        headers: authHeader(),
        timeout: 10000,
      });

      console.log(" Profile fetched successfully:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching profile:");
      console.error("Error message:", error.message);
      console.error("Error response:", error.response?.data);
      console.error("Error status:", error.response?.status);
      throw error;
    }
  },

  // -------------------------------------------
  // UPDATE PROFILE - Uses JWT token
  // Backend: @PostMapping("") with actionType="UPDATE"
  // URL: /api/seo-user
  // -------------------------------------------
  updateProfile: async (profileData) => {
    // Validation
    if (!profileData?.name?.trim()) {
      throw new Error("Name is required");
    }

    if (!profileData?.email?.trim()) {
      throw new Error("Email is required");
    }

    
    const storedUserData = localStorage.getItem('userData');
    let loginId = null;
    
    if (storedUserData) {
      try {
        const userData = JSON.parse(storedUserData);
        loginId = userData.loginId;
      } catch (e) {
        console.error('Error parsing stored user data:', e);
      }
    }

    if (!loginId) {
      throw new Error("User session invalid. Please login again.");
    }

    
    const cleanPhone = profileData.phone
      ? profileData.phone.toString().replace(/\D/g, "").replace(/^0+/, "") // Remove leading zeros
      : null;

    const cleanPincode = profileData.pincode
      ? profileData.pincode.toString().replace(/\D/g, "").replace(/^0+/, "") // Remove leading zeros
      : null;

    
    const payload = {
      loginId: loginId,  
      actionType: "UPDATE",  
      name: profileData.name.trim(),
      email: profileData.email.trim(),
      phone: cleanPhone || null,
      country: profileData.country?.trim() || null,
      state: profileData.state?.trim() || null,
      city: profileData.city?.trim() || null,
      pincode: cleanPincode || null,
      permanentAddress: profileData.permanentAddress?.trim() || null,
      currentAddress: profileData.currentAddress?.trim() || null,
      userType: profileData.userType || "Individual"
    };

    console.log("🔍 UPDATE Profile URL:", `${API_URL}/seo-user`);
    console.log("🔍 Auth Headers:", authHeader());
    console.log("📤 Payload:", payload);

    try {
      //  Use POST to /api/seo-user 
      const response = await axios.post(
        `${API_URL}/seo-user`,
        payload,
        {
          headers: {
            ...authHeader(),
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      console.log("✅ Profile updated successfully:", response.data);
      return response.data;

    } catch (error) {
      console.error("❌ Profile update failed:");
      console.error("Error message:", error.message);
      console.error("Error response:", error.response?.data);
      console.error("Error status:", error.response?.status);
      console.error("Request config:", error.config);
      
      // Check if it's a network error (no response from server)
      if (!error.response) {
        console.error("🚨 Network Error - Server not reachable or CORS issue");
        console.error("Check: 1) Backend is running, 2) API_URL is correct, 3) CORS is enabled");
      }
      
      throw error;
    }
  },

  // -------------------------------------------
  // DELETE ACCOUNT - Uses JWT token
  // Backend: @PostMapping("") with actionType="DELETE"
  // URL: /api/seo-user
  // -------------------------------------------
  deleteAccount: async (password) => {
  try {
    console.log("🔍 DELETE Account URL:", `${API_URL}/seo-user`);
    console.log("🔍 Auth Headers:", authHeader());

    // ✅ Validate password is provided
    if (!password || !password.trim()) {
      throw new Error("Password is required to delete account");
    }

    const storedUserData = localStorage.getItem('userData');
    let loginId = null;
    
    if (storedUserData) {
      try {
        const userData = JSON.parse(storedUserData);
        loginId = userData.loginId;
      } catch (e) {
        console.error('Error parsing stored user data:', e);
      }
    }

    if (!loginId) {
      throw new Error("User session invalid. Please login again.");
    }

    const payload = {
      loginId: loginId,
      actionType: "DELETE",
      rawPassword: password.trim()  // ✅ Send password for verification
    };

    console.log("📤 Delete Payload:", { ...payload, rawPassword: "***" });

    const response = await axios.post(
      `${API_URL}/seo-user`, 
      payload, 
      {
        headers: {
          ...authHeader(),
          "Content-Type": "application/json",
        },
        timeout: 10000,
      }
    );

    console.log("✅ Account deletion initiated:", response.data);
    return response.data;

  } catch (error) {
    console.error("❌ Account deletion failed:");
    console.error("Error message:", error.message);
    console.error("Error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    throw error;
  }
},
};

export default profileService;

// Optional: include auth headers if required
// headers: { 'Content-Type': 'application/json', ...authHeader() }

export const sendChangePasswordOtp = async (userName) => {
  return axios.post(
    `${API_URL}/seo-user/changePasswordOtp`,
    { userName },
    {
      headers: {
        ...authHeader(),
        "Content-Type": "application/json"
      }
    }
  );
};

export const validateOtp = async (userName, otp) => {
  return axios.post(
    `${API_URL}/seo-user/validateOtp`,
    {
      userName,
      otp
    },
    {
      headers: {
        ...authHeader(),
        "Content-Type": "application/json"
      }
    }
  );
};

export const changePassword = async (userName, newPassword) => {
  return axios.post(
    `${API_URL}/seo-user/changePassword`,
    {
      userName,
      newPassword
    },
    {
      headers: {
        ...authHeader(),
        "Content-Type": "application/json"
      }
    }
  );
};
